import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "auth-corner"
}
const _hoisted_2 = { class: "auth-corner-user-name" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "register-cta-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.showRegisterButton)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isAuthenticated)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_router_link, {
                to: "/account",
                class: "auth-corner-user"
              }, {
                default: _withCtx(() => [
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "auth-corner-user-icon" }, [
                    _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "8",
                        r: "4",
                        stroke: "currentColor",
                        "stroke-width": "1.8"
                      }),
                      _createElementVNode("path", {
                        d: "M4 20c0-3.9 3.6-7 8-7s8 3.1 8 7",
                        stroke: "currentColor",
                        "stroke-width": "1.8",
                        "stroke-linecap": "round"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.displayName), 1)
                ]),
                _: 1
              }),
              _createElementVNode("button", {
                type: "button",
                class: "auth-corner-logout",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                "aria-label": _ctx.jsonData.accountLogout
              }, _cache[3] || (_cache[3] = [
                _createElementVNode("svg", {
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M9 4.5H6.5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2H9",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }),
                  _createElementVNode("path", {
                    d: "M16 15.5l4-3.5-4-3.5M20 12H9.5",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)
              ]), 8, _hoisted_3)
            ], 64))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "register-cta",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openAuth && _ctx.openAuth(...args)))
            }, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "register-cta-glow" }, null, -1)),
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "register-cta-icon" }, "✦", -1)),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.jsonData.registerCtaLabel), 1)
            ]))
      ]))
    : _createCommentVNode("", true)
}